import * as Model from './index';
import axios, { AxiosResponse } from 'axios';

/**
 * Get AgFiniti growers using the configured start date
 *
 * @param user_id {string} the logged-in user id plus organization id {userId_orgId}
 * @param startDate {string} selected start date in UTC
 * @returns {AgFinitiGrowers}
 */
export const getAgFinitiGrowers = async (user_id: string, startDate: string) => {
  try {
    const cropwise_token: Model.Token | null = JSON.parse(
      window.localStorage.getItem('cropwise_auth_token') || '',
    );
    const access_token = cropwise_token ? cropwise_token['access_token'] : '';
    const response: AxiosResponse<Model.AgFinitiGrowers> = await axios.request({
      method: 'GET',
      url: `${import.meta.env.VITE_APP_API_URL}/valet/v2/agfiniti-growers`,
      headers: { authorization: `Bearer ${access_token}` },
      params: {
        user_id: user_id.split('_')[0],
        org_id: user_id.split('_')[1],
        start_date: startDate,
      },
    });
    if (!response.data?.growers) {
      return Promise.reject('Failed to retrieve growers');
    }
    return response.data;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};

/**
 * Get Farmobile companies
 *
 * @param user_id {string} the logged-in user id plus organization id {userId_orgId}
 * @returns {FarmobileOrganizations[]}
 */
export const getFarmobileOrganizations = async (user_id: string) => {
  try {
    const cropwise_token: Model.Token | null = JSON.parse(
      window.localStorage.getItem('cropwise_auth_token') || '',
    );
    const access_token = cropwise_token ? cropwise_token['access_token'] : '';
    const response: AxiosResponse<Model.FarmobileOrganizationsResponse> = await axios.request({
      method: 'GET',
      url: `${import.meta.env.VITE_APP_API_URL}/valet/v2/farmobile-orgs`,
      headers: { authorization: `Bearer ${access_token}` },
      params: {
        user_id: user_id.split('_')[0],
        org_id: user_id.split('_')[1],
      },
    });
    if (!response.data?.organizations) {
      return Promise.reject('Failed to retrieve organizations');
    }
    return response.data.organizations;
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  }
};
